/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateUserForManagerAction, UpdateUserForManagerActionTypes } from './types';

export interface UpdateUserForManagerState {
  loading: boolean;
  error?: Error;
  success: boolean;
}

export const initialUpdateUserForManagerState: UpdateUserForManagerState = {
  loading: false,
  error: null,
  success: false,
};

export default function updateUserForManagerReducer(
  state = initialUpdateUserForManagerState,
  action: UpdateUserForManagerAction,
) {
  switch (action.type) {
    case UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER:
      return update(state, {
        loading: { $set: true },
        success: { $set: false },
      });

    case UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_SUCCESS:
      return update(state, {
        loading: { $set: false },
        success: { $set: true },
      });

    case UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_ERROR:
      return update(state, {
        loading: { $set: false },
        success: { $set: false },
        error: { $set: action.error },
      });

    case UpdateUserForManagerActionTypes.RESET_ERROR:
      return update(state, {
        error: { $set: initialUpdateUserForManagerState.error },
      });

    case UpdateUserForManagerActionTypes.RESET_STATE_UPDATE_USER_FOR_MANAGER:
      return initialUpdateUserForManagerState;

    default:
      return state;
  }
}
